import { Button, FormItem, Heading, Input } from '../Ant';
import { ArrowRight } from '../icons';
import MatterRequestHomeCountrySelect from './matterRequestHomeCountrySelect';
import { IMatterRequest } from '../../interface/matterRequest';
import { ICustomerType } from '../../constants/customer';
import { useTranslation } from 'react-i18next';
import PinnedSaveButton from '../pinnedSaveButton/pinnedSaveButton';

interface NewCustomerFormProps {
  matterRequest: IMatterRequest | null;
  updateManageMatterRequest: (data: IMatterRequest | null, reset?: boolean) => void;
  handleSelectCustomerType: () => void;
  handleSelectHomeCountry: () => void;
  handleContinueToDetails: () => void;
  isNewCustomerFormDisabled: boolean;
}

const NewCustomerForm: React.FC<NewCustomerFormProps> = ({
  matterRequest,
  updateManageMatterRequest,
  handleSelectCustomerType,
  handleSelectHomeCountry,
  handleContinueToDetails,
  isNewCustomerFormDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <FormItem label={t('matterRequest:type')} required>
        <div className="relative">
          <Button
            type="default"
            data-testid="select-customer-type-button"
            data-field="customerType"
            className="add-transaction-btn"
            block
            onClick={handleSelectCustomerType}
          >
            {matterRequest?.newCustomer?.type ? (
              <div className="d-flex justify-between w-full items-center selected-values">
                <Heading
                  level={6}
                  $fontsize="13px"
                  $color="title"
                  $weight={400}
                  $lineheight="20px"
                  className="ta-left lineclamp-1"
                  data-testid="selected-home-country"
                >
                  {matterRequest.newCustomer.type === ICustomerType.COMPANY
                    ? t('customer:customerType.company')
                    : t('customer:customerType.privatePerson')}
                </Heading>
              </div>
            ) : (
              <div className="d-flex justify-between w-full items-center preselection-field">
                <span>{t('matterRequest:selectType')}</span>
                <ArrowRight />
              </div>
            )}
          </Button>
          {matterRequest?.newCustomer?.type && (
            <Button type="text" className="change-value-btn" onClick={handleSelectCustomerType}>
              {t('common:change')}
            </Button>
          )}
        </div>
      </FormItem>
      <FormItem
        label={
          matterRequest?.newCustomer?.type === ICustomerType.PRIVATE_PERSON
            ? t('customer:firstName')
            : t('customer:name')
        }
        required
      >
        <Input
          value={matterRequest?.newCustomer?.name}
          placeholder={
            matterRequest?.newCustomer?.type === ICustomerType.PRIVATE_PERSON
              ? t('customer:firstName')
              : t('customer:enterName')
          }
          onChange={(event) => {
            updateManageMatterRequest({
              ...matterRequest,
              newCustomer: {
                ...matterRequest?.newCustomer,
                name: event.target.value,
              },
            } as unknown as IMatterRequest);
          }}
        />
      </FormItem>
      {matterRequest?.newCustomer?.type === ICustomerType.PRIVATE_PERSON && (
        <FormItem label={t('customer:lastName')} required>
          <Input
            placeholder={t('customer:enterLastName')}
            value={matterRequest?.newCustomer?.lastName}
            onChange={(event) => {
              updateManageMatterRequest({
                ...matterRequest,
                newCustomer: {
                  ...matterRequest?.newCustomer,
                  lastName: event.target.value,
                },
              } as unknown as IMatterRequest);
            }}
          />
        </FormItem>
      )}
      <FormItem label={t('common:homeCountry')} required>
        <div className="relative">
          <MatterRequestHomeCountrySelect onOpenPicker={handleSelectHomeCountry} />
        </div>
      </FormItem>
      <PinnedSaveButton
        data-testid="create-button"
        disabled={isNewCustomerFormDisabled}
        onClick={handleContinueToDetails}
      >
        {t('matterRequest:continueToDetails')}
      </PinnedSaveButton>
    </>
  );
};

export default NewCustomerForm;
